export const SIDEBAR_ROUTE_SEGMENTS = ['applications', 'products', 'accounts', 'quotes'];
